import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';

import {
  fetchAccountRestrictions,
} from '../../actions';

import Tooltip from '../Tooltip';
import './styles.css';
import { LAYOUT } from '../Layout/enums';
import { SUPPORT_EMAIL } from '../../actions/urls';

const getStyleSuffix = (layout) => {
  let styleSuff = '';
  switch (layout) {
    case LAYOUT.TAB:
      styleSuff = 'Tab';
      break;
    case LAYOUT.MOB:
      styleSuff = 'Mob';
      break;
    // no default
  }
  return styleSuff;
};

export class UnconnectedRestrictions extends Component {
  componentDidMount() {
    this.props.fetchAccountRestrictions(this.props.accountNumber);
  }

  getRestrictionItem = (restrict, layout) => {
    const {
      accountRestrictionId,
      reason,
      type,
    } = restrict;
    const isMobile = layout === LAYOUT.MOB;
    const styleSuff = getStyleSuffix(layout);
    const name = get(reason, 'name', '');
    const comments = get(type, 'description', null);
    const inputLabel = isMobile ? 'Required Document: ' : '';
    let input = (<a styleName="link" href={`mailto:${SUPPORT_EMAIL}`}>Please contact support</a>);
    if (name.toLowerCase() === 'industry affiliation') {
      input = (
        <a styleName="link" target="_blank" href="/static/docs/My_IPO_FINRA_Member_Approval_Form_-_final_v7jb.pdf">
          {inputLabel}FINRA Member Approval Form
        </a>);
    }
    if (name.toLowerCase() === 'cip failure') {
      input = (
        <div styleName={`labelGrey${styleSuff}`}>
          {inputLabel}Image of government issued ID
        </div>);
    }
    return (
      <React.Fragment>
        <div key={accountRestrictionId} styleName="bankLinkRow">
          <div styleName="labelGrey">{name}</div>
          {comments ?
            <div styleName="tooltip" >
              <Tooltip text={comments} />
            </div> : null}
          <div styleName="filler" />
          {!isMobile ? input : null}
        </div>
        {isMobile ? input : null}
      </React.Fragment>
    );
  };

  render() {
    const {
      layout,
      accountRestrictions,
      userId,
    } = this.props;
    const isMobile = layout === LAYOUT.MOB;
    const styleSuff = getStyleSuffix(layout);
    const uploadLink = <Link styleName="uploadDocLink" to={`/user/${userId}/upload-document`}>Upload document</Link>;
    return (
      accountRestrictions.length > 0 ?
        <div styleName={`formGroupRed${styleSuff}`}>
          <div styleName="flexRow">
            <div styleName={`labelRed${styleSuff}`}>Account Restrictions</div>
            {!isMobile ?
              <React.Fragment>
                {uploadLink}
                <div styleName="filler" />
                <div styleName={`labelBlack${styleSuff}`}>Required Documents</div>
              </React.Fragment> : null
            }
          </div>
          {isMobile ? uploadLink : null}
          {accountRestrictions.map(restrict =>
            this.getRestrictionItem(restrict, layout))}
        </div> : null
    );
  }
}

UnconnectedRestrictions.propTypes = {
  layout: PropTypes.number,
  accountNumber: PropTypes.string,
};

UnconnectedRestrictions.defaultProps = {
  accountNumber: 'unknown',
  layout: LAYOUT.DESK,
};


const mapStateToProps = (state, props) => ({
  userId: get(state, 'user.data.id'),
  accountRestrictions: get(state, `accountRestrictionsByAccount.[${props.accountNumber}].data`, []),
});

const mapDispatchToProps = {
  fetchAccountRestrictions,
};


export default connect(mapStateToProps, mapDispatchToProps)(UnconnectedRestrictions);



// WEBPACK FOOTER //
// ./src/components/ManageAccount/Restrictions.js